import React, { Component } from "react";

class CollapsableRow extends Component {
  constructor() {
    super();
    this.state = {
      Active: false
    };
  }
  style = {
    button: {
      width: "77px",
      height: "29px",
      fontSize: "16px",
      color: "#414141"
    }
  };

  toggle = () => {
    this.setState({
      ...this.state,
      Active: !this.state.Active
    });
  };

  render() {
    return (
      <div onClick={this.toggle}>
        {this.props.data.persistent}
        {this.state.Active ? this.props.data.collapsable : ""}
      </div>
    );
  }
}

export default CollapsableRow;
